module.exports = ["Requesting full site","Resolving DNS","Measuring time to first byte","Testing TCP connection time","Checking for HTTPS","Verifying SSL certificates","Connecting from New York","Connecting from Tokyo","Connecting from San Francisco","Connecting from Sydney","Connecting from London","Connecting from São Paulo"]


//////////////////
// WEBPACK FOOTER
// ./src/data/loading.json
// module id = 109
// module chunks = 0 1